import { http } from "frontend/src/api/client";
import { mapTrackObject } from "frontend/src/api/tracks/map";
var mapSchedule = function (schedule) { return ({
    id: schedule.id,
    clientId: schedule.client_id,
    title: schedule.title,
    isEnabled: schedule.is_enabled,
    musicWindows: schedule.music_windows.map(function (item) { return ({
        id: item.id,
        playlistId: item.playlist_id,
        playlistTitle: item.playlist_title,
        daysEnabled: item.days_enabled,
        timeStart: item.time_start.slice(0, 5),
        timeEnd: item.time_end.slice(0, 5),
        playOrder: item.play_order,
        sortOrder: item.sort_order,
    }); }),
    advertisements: schedule.advertisements.map(function (item) { return ({
        id: item.id,
        trackId: item.track_id,
        trackTitle: item.track_title,
        daysEnabled: item.days_enabled,
        timeStart: item.time_start.slice(0, 5),
        timeEnd: item.time_end.slice(0, 5),
        repeatIntervalMinutes: item.repeat_interval_minutes,
        interruptPlaying: item.interrupt_playing,
        sortOrder: item.sort_order,
    }); }),
}); };
var mapPayload = function (schedule) { return ({
    title: schedule.title,
    is_enabled: schedule.isEnabled,
    music_windows: schedule.musicWindows.map(function (item, index) {
        var _a;
        return ({
            playlist_id: item.playlistId,
            days_enabled: item.daysEnabled,
            time_start: item.timeStart,
            time_end: item.timeEnd,
            play_order: item.playOrder,
            sort_order: (_a = item.sortOrder) !== null && _a !== void 0 ? _a : index,
        });
    }),
    advertisements: schedule.advertisements.map(function (item, index) {
        var _a;
        return ({
            track_id: item.trackId,
            days_enabled: item.daysEnabled,
            time_start: item.timeStart,
            time_end: item.timeEnd,
            repeat_interval_minutes: item.repeatIntervalMinutes,
            interrupt_playing: item.interruptPlaying,
            sort_order: (_a = item.sortOrder) !== null && _a !== void 0 ? _a : index,
        });
    }),
}); };
export var getWebSchedules = function () {
    return http.api
        .get("web-schedules")
        .then(function (response) {
        var data = response.data.data;
        var schedules = Array.isArray(data) ? data : data.data;
        return schedules.map(mapSchedule);
    });
};
export var getWebSchedule = function (id) {
    return http.api
        .get("web-schedules/" + id)
        .then(function (response) { return mapSchedule(response.data.data); });
};
export var createWebSchedule = function () {
    return http.api
        .post("web-schedules", {
        title: "Новое расписание",
        is_enabled: true,
        music_windows: [],
        advertisements: [],
    })
        .then(function (response) { return mapSchedule(response.data.data); });
};
export var updateWebSchedule = function (schedule) {
    return http.api
        .put("web-schedules/" + schedule.id, mapPayload(schedule))
        .then(function (response) { return mapSchedule(response.data.data); });
};
export var deleteWebSchedule = function (id) {
    return http.api.delete("web-schedules/" + id).then(function () { return undefined; });
};
var mapPlayerTrack = function (track) { return mapTrackObject(track); };
export var getWebSchedulePlayer = function (id) {
    return http.api
        .get("web-schedules/" + id + "/player")
        .then(function (response) {
        var _a, _b, _c;
        var data = response.data.data;
        return {
            id: data.id,
            title: data.title,
            musicWindows: ((_b = (_a = data.music_windows) !== null && _a !== void 0 ? _a : data.musicWindows) !== null && _b !== void 0 ? _b : []).map(function (item) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
                return ({
                    id: item.id,
                    playlistId: (_b = (_a = item.playlist_id) !== null && _a !== void 0 ? _a : item.playlistId) !== null && _b !== void 0 ? _b : (_c = item.playlist) === null || _c === void 0 ? void 0 : _c.id,
                    playlistTitle: (_g = (_e = (_d = item.playlist_title) !== null && _d !== void 0 ? _d : item.playlistTitle) !== null && _e !== void 0 ? _e : (_f = item.playlist) === null || _f === void 0 ? void 0 : _f.title) !== null && _g !== void 0 ? _g : "",
                    daysEnabled: (_h = item.days_enabled) !== null && _h !== void 0 ? _h : item.daysEnabled,
                    timeStart: (_j = item.time_start) !== null && _j !== void 0 ? _j : item.timeStart,
                    timeEnd: (_k = item.time_end) !== null && _k !== void 0 ? _k : item.timeEnd,
                    playOrder: (_m = (_l = item.play_order) !== null && _l !== void 0 ? _l : item.playOrder) !== null && _m !== void 0 ? _m : "forward",
                    tracks: ((_q = (_o = item.tracks) !== null && _o !== void 0 ? _o : (_p = item.playlist) === null || _p === void 0 ? void 0 : _p.tracks) !== null && _q !== void 0 ? _q : []).map(mapPlayerTrack),
                });
            }),
            advertisements: ((_c = data.advertisements) !== null && _c !== void 0 ? _c : []).map(function (item) {
                var _a, _b, _c, _d, _e, _f;
                return ({
                    id: item.id,
                    trackId: (_a = item.track_id) !== null && _a !== void 0 ? _a : item.trackId,
                    daysEnabled: (_b = item.days_enabled) !== null && _b !== void 0 ? _b : item.daysEnabled,
                    timeStart: (_c = item.time_start) !== null && _c !== void 0 ? _c : item.timeStart,
                    timeEnd: (_d = item.time_end) !== null && _d !== void 0 ? _d : item.timeEnd,
                    repeatIntervalMinutes: (_e = item.repeat_interval_minutes) !== null && _e !== void 0 ? _e : item.repeatIntervalMinutes,
                    interruptPlaying: Boolean((_f = item.interrupt_playing) !== null && _f !== void 0 ? _f : item.interruptPlaying),
                    track: item.track ? mapPlayerTrack(item.track) : null,
                });
            }),
        };
    });
};
